/**
 * Manages the state and actions for editing a section's name in-place.
 */
import { useState, useEffect, useRef } from 'react';

export const useSectionNameEdit = (section, renameSection, activePageId) => {
    const [isEditing, setIsEditing] = useState(section.isNew || false);
    const [name, setName] = useState(section.name);
    const inputRef = useRef(null);

    // Automatically focus the input when editing begins
    useEffect(() => {
        if (isEditing) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [isEditing]);

    const handleRename = () => {
        setIsEditing(false);
        const sanitizedName = name.replace(/<[^>]*>?/gm, ''); // Basic sanitization
        if (sanitizedName && sanitizedName !== section.name) {
            renameSection({ pageId: activePageId, sectionId: section.id, newName: sanitizedName });
        } else {
            setName(section.name); // Revert if name is empty or unchanged
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleRename();
        if (e.key === 'Escape') {
            setIsEditing(false);
            setName(section.name);
        }
    };

    return {
        isEditing,
        name,
        inputRef,
        setName,
        setIsEditing,
        handleRename,
        handleKeyDown,
    };
};